<template>
	<div class="left-box">
		<div v-if="list.length > 0">
			<section class="context">
				<div class="item" :class="{'active': active_id == item.id}" v-for="(item, index) in list" :key="index" @click.stop="handelView(item)">
					<div class="top">
						<span class="title" v-if="listQuery.type == 'single'">{{item.customerName || (isShowPhone ? item.mobileNum : hiddenPhone(item.mobileNum))}}</span>
						<span class="title" v-else>{{item.remark || (`群发：共${item.sendCount}人`)}}</span>
						<span class="time" :class="{'ready': (item.sendStatus == 'ready' && item.scheduleTime)}">{{((item.sendStatus == 'ready' && item.scheduleTime) ? (item.scheduleTime) : (item.createTime)) | formatDate}}</span>
					</div>
					<div class="bottom">
						<span class="title">{{item.smsBody}}</span>
						<span class="time" v-if="listQuery.type == 'single'">
							<el-tooltip class="item" effect="dark" content="预约中" placement="right">
								<svg-icon v-if="item.sendStatus == 'ready' && item.scheduleTime" icon-class="alarm-line" style="color: #e6a23c" />
							</el-tooltip>
							<el-tooltip class="item" effect="dark" content="待发送" placement="right">
								<svg-icon v-if="item.sendStatus == 'ready' &&  !item.scheduleTime" icon-class="alarm-loading" style="color: #e6a23c" />
							</el-tooltip>
							<el-tooltip class="item" effect="dark" content="系统已发送，等待运营商返回结果" placement="right">
								<svg-icon v-if="item.sendStatus == 'sent' && !item.providerStatus" icon-class="mail-send-line" style="color: #409EFF" />
							</el-tooltip>
							<el-tooltip class="item" effect="dark" content="发送成功" placement="right">
								<svg-icon v-if="item.sendStatus == 'sent' && item.providerStatus == 'success'" icon-class="mail-check-line" style="color: #67C23A" />
							</el-tooltip>
							<el-tooltip class="item" effect="dark" content="系统已发送，运营商未发送成功" placement="right">
								<svg-icon v-if="item.sendStatus == 'sent' && item.providerStatus && item.providerStatus != 'success'" icon-class="mail-close-line" style="color: #F56C6C" />
							</el-tooltip>
							<el-tooltip class="item" effect="dark" content="系统发送失败" placement="right">
								<svg-icon v-if="item.sendStatus == 'failed'" icon-class="close-circle-line" style="color: #ff0000" />
							</el-tooltip>
							<el-tooltip class="item" effect="dark" content="已取消" placement="right">
								<svg-icon v-if="item.sendStatus == 'cancel'" icon-class="mail-forbid-line" style="color: #909399" />
							</el-tooltip>
							
							<!-- <i :class="item.sendStatus">{{sendStatusObj[item.sendStatus]}}</i> -->
							<!-- <i v-if="item.providerStatus" :class="item.providerStatus == 'success' ? 'sent el-icon-circle-check' : 'failed el-icon-circle-close'"></i> -->
						</span>
						<span class="time" v-else>
							<i class="sent el-icon-circle-check" style="margin-right: 12px"> {{item.successCount}}</i>
							<i class="failed el-icon-circle-close"> {{item.failedCount}}</i>
						</span>
					</div>
				</div>
			</section>
			<section class="page-box">
			<el-button @click.stop="handlePage('pre')" :disabled="listQuery.pageNum == 1" size="mini" type="primary">上一页</el-button>
			<span class="page">{{total == 0 ? 0 : listQuery.pageNum}} / {{Math.ceil(total / listQuery.pageSize)}}</span>
			<el-button @click.stop="handlePage('next')" :disabled="listQuery.pageNum == Math.ceil(total / listQuery.pageSize)" size="mini" type="primary">下一页</el-button>
		</section>
		</div>

		<el-empty v-else description="暂无数据"></el-empty>
	</div>
</template>

<script>
import { mapGetters } from "vuex";
import { tableMixin } from "utils/mixins";
export default {
	props: ['listQuery', 'sendCount'],
	mixins: [tableMixin],
	computed: {
        ...mapGetters([
			'isShowPhone'
        ])
    },
	data() {
		return {
			list: [],
			total: 0,
			active_id: '',
			sendStatusObj: {
				'ready': '预约中',
				'sent': '已发送',
				'failed': '已失败',
				'cancel': '已取消'
			}
		}
	},
	watch: {
		sendCount: {
			handler() {
				this.getList();
			},
			deep: true,
			immediate: true
		}
	},
	methods: {
		getList() {
			console.log('=======', this.listQuery.type)
			if(this.listQuery.type == 'single') {
				console.log(222)
				this.$api.apiPostSmsSendSingleList(this.listQuery).then(response => {
					if(response.errcode != 0) return;
					this.list = response['list'];
					this.total = response.total;
					this.handelView(this.list.length > 0 ? this.list[0] : {});
				});
			}else{
				console.log(333)
				this.$api.apiPostSmsSendGroupList(this.listQuery).then(response => {
					if(response.errcode != 0) return;
					this.list = response['list'];
					this.total = response.total;
					this.handelView(this.list.length > 0 ? this.list[0] : {});
				});
			}
		},
		handelView(row) {
			console.log(row)
			this.active_id = row.id;
			this.$emit('onEmitItemData', row);
		},
		handlePage(type) {
			if(type === 'pre') {
				this.listQuery.pageNum--;
			}
			if(type === 'next'){
				this.listQuery.pageNum++;
			}
			this.getList();
		},
		hiddenPhone(phone) {
			if (!phone) return ''
			return phone.substr(0, 3) + '****' + phone.substr(phone.length - 4);
		},
	}
}
</script>

<style lang="scss" scoped>

.svg-icon {
	font-size:  18px;
}
.left-box {
	width: 100%;
	height: 100%;
	position: relative;

	& .context {
		height: calc(100% - 50px);
		overflow-x: hidden;
		overflow-y: auto;
		& > .item {
			width: 100%;
			height: 60px;
			border-bottom: solid 1px #e1e1e1;
			cursor: pointer;

			&.active {
				background: #edf5ff;
			}

			&:hover {
				background: #f7f8fa;
			}

			& > .top {
				width: 100%;
				height: 30px;
				line-height: 30px;
				padding: 0 8px;
				box-sizing: border-box;

				& > .title {
					font-size: 14px;
					font-weight: bold;
					color: #333;
					display: inline-block;
					width: calc(100% - 150px);
					overflow: hidden;
					white-space: nowrap;
					text-overflow: ellipsis;
					vertical-align: top;
				}

				& > .time {
					display: inline-block;
					width: 150px;
					font-size: 12px;
					color: #666;
					text-align: right;
					vertical-align: top;

					&.ready {
						color: #e6a23c;
					}
				}
			}

			& > .bottom {
				width: 100%;
				height: 30px;
				line-height: 30px;
				padding: 0 8px;
				box-sizing: border-box;

				& > .title {
					font-size: 12px;
					color: #666;
					display: inline-block;
					width: calc(100% - 100px);
					overflow: hidden;
					white-space: nowrap;
					text-overflow: ellipsis;
					vertical-align: top;
				}

				& > .time {
					display: inline-block;
					width: 100px;
					font-size: 12px;
					color: #666;
					text-align: right;
					vertical-align: top;

					& > i {
						font-style: normal;

						&.ready {
							color: #e6a23c;
						}

						&.sent {
							color: #67c23a;
						}

						&.failed {
							color: #f56c6c;
						}
					}
				}
			}
		}
	}

	& .page-box {
		width: 100%;
		height: 50px;
		text-align: center;
		position: absolute;
		bottom: 0;
		background: #fff;
		
		& > .page {
			display: inline-block;
			width: 100px;
			line-height: 50px;
			text-align: center;
		}
	}
}
</style>